// @ts-ignore
import React from "react";

import { MeResponse } from "@atlassiansox/asc-stargate";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";

import { JiraSoftwarePageTemplate } from "../../templates/jira-software-page/src";

export type JiraSoftwarePageProps = {
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
};

export const JiraSoftwarePage = (props: JiraSoftwarePageProps) => (
    <JiraSoftwarePageTemplate
        availableProducts={props.availableProducts}
        userProfile={props.userProfile}
    />
);
